export default __webpack_public_path__ + "static/media/trener5.e6103341.png";